import * as React from 'react'

import { NextPage } from '@grandvisionhq/next'
import {
  ErrorCase,
  InitialProps,
  Page,
  Props,
} from '@grandvisionhq/www-next/pages/product-detail/solutions'

import { composePDP } from '../../../components/hocs/compose-pdp'
import { settings as cartSettings } from '../../../components/hocs/with-cart'
import { excludeSkuFromProductUrls } from '../../../configuration/manifest'

const ProductDetailPage: NextPage<Props, InitialProps | ErrorCase> = (props) => (
  <Page {...props} maxOrderableQuantity={cartSettings.maximumQuantity} />
)

const getInitialProps = Page.getInitialProps
if (getInitialProps) {
  ProductDetailPage.getInitialProps = (ctx) =>
    getInitialProps({ ...ctx, pageConfig: { excludeSkuFromProductUrls } })
}

export default composePDP<Props>(ProductDetailPage)
